import React from 'react';
import mail2 from './../../../assets/img/brand/pzu/mail2.png';
import post from './../../../assets/img/brand/pzu/post.png';
import calendar2 from './../../../assets/img/brand/pzu/calendar2.png';

const ZasadyPrzystepowania = (props) => {
  return (
    <React.Fragment>
      <h3 className="page-header firstColor">
        Jak przystąpić do ubezpieczenia zdrowotnego
      </h3>
      <div className="secondColor">
        <p>
          W ramach <b>ubezpieczenia TUW PZUW</b> możesz rozszerzyć opiekę
          medyczną również o <b>pakiet dla dorosłego dziecka</b> – czyli dziecka
          pracownika, współpracownika lub byłego pracownika, które ukończyło 26
          rok życia.
        </p>

        <p>
          Aby objąć ubezpieczeniem dorosłe dziecko, wypełnij{' '}
          <b>formularz online</b>, a następnie <b>wydrukuj deklarację</b> i{' '}
          <b>przekaż do podpisania członkowi rodziny.</b> Dla każdego członka
          rodziny w tym pakiecie konieczne jest wypełnienie odrębnej deklaracji.
        </p>

        <p>
          Pamiętaj, że <b>składki za ubezpieczenie dorosłego dziecka</b> są
          opłacane indywidualnie — na numer subkonta bankowego wskazany w
          deklaracji.
        </p>

        <p>
          Aby móc zgłosić dorosłe dziecko do ubezpieczenia, musisz posiadać{' '}
          <b>aktywny pakiet opieki medycznej</b> jako pracownik, współpracownik
          lub były pracownik.
        </p>

        <br />
        <p>Wypełnioną i podpisaną deklarację prześlij:</p>

        <div className="container mt-4 ml-5">
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center justify-content-end">
              <img src={mail2} alt="mail" />
            </div>
            <div className="col-sm-11">
              w formie skanu lub zdjęcia
              <br />
              na adres mailowy:{' '}
              <a href="mailto:deklaracje@datus.pl">
                <b>deklaracje@datus.pl</b>
              </a>
            </div>
          </div>
        </div>

        <div className="container mt-4 ml-5">
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center justify-content-end">
              <img src={post} alt="post" />
            </div>
            <div className="col-sm-11">
              lub listownie na adres:
              <br />
              <b>Datus Sp. z o.o.</b>
              <br />
              ul. Obrzeżna 7
              <br />
              02-691 Warszawa
            </div>
          </div>
        </div>

        <div className="container mt-4">
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center justify-content-end">
              <img src={calendar2} alt="calendar" />
            </div>
            <div className="col-sm">
              Aby zostać objętym ubezpieczeniem zdrowotnym od{' '}
              <b>1 dnia miesiąca</b>, wypełnij, opłać i prześlij deklarację do{' '}
              <b>
                20 dnia miesiąca poprzedzającego rozpoczęcie ochrony
                ubezpieczeniowej
              </b>
              , np. jeśli wypełnisz deklarację do <b>20 listopada</b> – opieka
              medyczna rozpocznie się od <b>1 grudnia</b>; jeśli wypełnisz
              formularz pomiędzy <b>21 listopada</b> a <b>20 grudnia</b> opieka
              medyczna rozpocznie się 1 stycznia.
            </div>
          </div>
        </div>

        <br />
        <p>
          Termin opłaty składki upływa <b>20 dnia miesiąca</b> poprzedzającego
          miesiąc ochrony ubezpieczeniowej. Nieopłacenie składki w terminie
          będzie skutkowało <b>zakończeniem ubezpieczenia.</b>
        </p>

        <br />
        <p className="firstColor">
          <b>
            Ponowne przystąpienie do ubezpieczenia możliwe jest wyłącznie w
            rocznicę umowy, tj. 01.01.2027 r.
          </b>
        </p>
      </div>
    </React.Fragment>
  );
};

export default ZasadyPrzystepowania;
